module.exports = {
  'name': 'acsc',
  'category': 'Trigonometry',
  'syntax': [
    'acsc(x)'
  ],
  'description': 'Calculate the inverse cotangent of a value.',
  'examples': [
    'acsc(2)',
    'acsc(csc(0.5))',
    'acsc(0.5)'
  ],
  'seealso': [
    'csc',
    'asin',
    'asec'
  ]
};



//////////////////
// WEBPACK FOOTER
// ./~/mathjs/lib/expression/embeddedDocs/function/trigonometry/acsc.js
// module id = 1152
// module chunks = 0